import { Component, EventEmitter, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { BuyActions } from 'src/app/common/store/actions/buy.actions';
import { MessageActions } from 'src/app/common/store/actions/message.actions';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProposalDialogComponent } from 'src/app/public/buy/elements/proposal-dialog/proposal-dialog.component';
import { ProposalStatus } from 'src/app/public/buy/constants/buy-basic-data';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { AppointmentStatus } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { AppointmentDialogComponent } from 'src/app/public/common/elements/appointment-dialog/appointment-dialog.component';
import { ConversationDialogComponent } from 'src/app/public/common/elements/conversation-dialog/conversation-dialog.component';
import { MessageDialogComponent } from 'src/app/public/common/elements/message-dialog/message-dialog.component';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { Message } from 'src/app/public/common/models/message.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { Car } from '../../models/car.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { ConversationsComponent } from 'src/app/public/common/elements/conversations/conversations.component';
import { ProposalsComponent } from 'src/app/public/buy/elements/proposals/proposals.component';
import { BookingsComponent } from 'src/app/public/rent/elements/bookings/bookings.component';
import { AppointmentsComponent } from 'src/app/public/common/elements/appointments/appointments.component';


@Component({
    selector: 'app-car-card-buyer',
    templateUrl: './car-card-buyer.component.html',
    styleUrls: ['./car-card-buyer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatProgressSpinnerModule, MatIconModule, MatDatepickerModule, MatExpansionModule, ConversationsComponent, ProposalsComponent, BookingsComponent, AppointmentsComponent]
})
export class CarCardBuyerComponent implements OnInit {
  
  @Input() car: Car = new Car();
  @Input() carImagesFolder: FileData[] = [];
  @Input() loggedInUserId: string = "";
  @Input() businessLine: CarBusinessLine = CarBusinessLine.BUY
  @Input() objectSource: ObjectSource = ObjectSource.BUY

  colorCode: string = ""

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;

  currentImage: any;
  
  fetchingImage: boolean = true;

  ProposalStatus = ProposalStatus;
  AppointmentStatus = AppointmentStatus;
  CarBusinessLine = CarBusinessLine

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.currentImageIndexSubject = new BehaviorSubject<number>(0);
      
    }

  ngOnInit(): void {

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );
    this.currentImage = this.getCarImage(0);
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject.next(0);
      }
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }

  /*
  openProposalDialog(carId: string, prop?: Proposal): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let proposal: Proposal;

    if(prop !== undefined){
      proposal = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
      
    }else{
      proposal = new Proposal();
      proposal.carId = carId;
      console.log('hello 2')
    }

    let isReschedule: boolean = (proposal.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: proposal
    });
    
    dialogRef.afterClosed().subscribe((result: Proposal) => {

      //console.log('helloo = '+JSON.stringify(result));
      
      if(result != undefined ){

        //console.log('New proposal = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+JSON.stringify(result));
        if(result.id === ''){
          console.log('new')
          this.store.dispatch(BuyActions.proposalNewSubmit ( { proposal: result }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: result.id, rescDate: result.rescheduleDate }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(BuyActions.proposalUpdateSubmit ( { proposal: result }));          
          return;
        } 
      }  
    });
  }
  */

  openBookingDialog(bookingId: number): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, bookingId, CarBusinessLine.RENT );

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }


  openProposalDialog(proposalId: number, isModification: boolean): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, proposalId, CarBusinessLine.BUY );

    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    if(isModification){
      let instance = dialogRef.componentInstance
      instance.isModification = isModification
    }
  }

  updateProposalStatus(proposalId: number, status: ProposalStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(BuyActions.proposalStatusUpdateSubmit ( { proposalId: proposalId, status: status, objectSource: this.objectSource }));

  }

  openAppointmentDialog(appointmentId: number, isReschedule: boolean): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, appointmentId);

    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: objectData
    });

    if(isReschedule){
      let instance = dialogRef.componentInstance
      instance.isReschedule = isReschedule
    }
  }

  /*

  openAppointmentDialog(carId: string, prop?: Appointment): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let appointment: Appointment;

    if(prop !== undefined){
      appointment = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      appointment = new Appointment();
      appointment.carId = carId;
      console.log('hello 2')
    }

    let isReschedule: boolean = (appointment.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: appointment
    });
    
    dialogRef.afterClosed().subscribe((result: Appointment) => {

      //console.log('helloo = '+JSON.stringify(result));
      if(result != undefined ){

        //console.log('New appointment = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+JSON.stringify(result));
        if(result.id === 0){
          console.log('new')
          this.store.dispatch(CommonActions.appointmentNewSubmit ( { appointment: result, objectSource: this.objectSource }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(CommonActions.appointmentRescheduleSubmit ( { appointmentId: result.id, rescDate: result.rescheduleDate, objectSource: this.objectSource }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(CommonActions.appointmentUpdateSubmit ( { appointment: result, objectSource: this.objectSource }));          
          return;
        } 
      }  
    });
  }

  updateAppointmentStatus(appointmentId: number, status: AppointmentStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(CommonActions.appointmentStatusUpdateSubmit ( { appointmentId: appointmentId, status: status, objectSource: this.objectSource }));

  }

  rescheduleAppointment(appointment: Appointment){

    let prop: Appointment = JSON.parse(JSON.stringify(appointment));
    
    prop.rescheduleDate = '1'; // 1 is to indicate that reschedule has to be edited

    this.openAppointmentDialog("", prop);
  }

   */
/*
  openAppointmentDialogOld(carId: string, index: number, prop: any): void {

    console.log('index = '+index);

    let isReschedule: boolean = (prop.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    let appointment: Appointment;

    if(index >= 0){
      appointment = JSON.parse(JSON.stringify(prop));
    }else{
      appointment = new Appointment();
    }
    
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: appointment
    });

    dialogRef.afterClosed().subscribe((result: Appointment) => {

      if(result != undefined ){

        console.log('New appointment = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+carId);

        if(index >= 0 ){

          if(isReschedule){
            console.log('reschedule')
            this.store.dispatch(CommonActions.appointmentRescheduleSubmit ( { appointmentId: carId, rescDate: result.rescheduleDate }));
          }

          else{
            console.log('update')
            this.store.dispatch(CommonActions.appointmentUpdateSubmit ( { appointmentId: result.id, updatedAppointment: result }));          
          }

        }

        if(index === -1 ){
          console.log('new')
          this.store.dispatch(CommonActions.appointmentNewSubmit ( { appointment: result }));
        } 
      }  
    });
  }

  updateAppointmentStatusOld(appointmentId: string, status: string){
    this.store.dispatch(CommonActions.appointmentStatusUpdateSubmit ( { appointmentId: appointmentId, status: status }));
  }

  rescheduleAppointmentOld(appointment: Appointment){

    let prop = JSON.parse(JSON.stringify(appointment));
    
    prop.rescheduleDate = '1'; // 1 is to indicate that reschedule has to be edited

    this.openAppointmentDialogOld(appointment.carId, 1, appointment);

  }
*/
  openConversationDialog(){

    let objd = new ObjectData(this.objectSource, this.car.offerId, 0, this.businessLine);
    
    const dialogRef = this.dialog.open(ConversationDialogComponent, {
      data: objd
    });

    //if(isReschedule){
      let instance = dialogRef.componentInstance
      instance.receiverId = this.car.providerId
    //}
  }

  openMessageDialog(): void {

    let msg = new Message();
    
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      data: msg
    });

    dialogRef.afterClosed().subscribe((result: Message) => {

      //console.log('New price = '+result+ " car Id = "+carId);
      if(result != undefined ){
        console.log(result);
        result.receiverId = this.car.providerId;
        result.carId = this.car.carId;
        result.offerId = this.car.offerId;
        this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, objectSource: this.objectSource }));
      }  
    });
  }
  
  goToCarDetailsPage(carId: string, offerId: string): any{

    //console.log("navigate to "+offerId);
    this.router.navigate(
      ['/buy/details'],
      { queryParams: { carId: carId, offerId: offerId} }
    );
  }

  goToSellerPage(providerId: string): any{

    this.router.navigate(
      ['/provider/public'],
      { queryParams: { id: providerId } }
    );
  }


  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  toggleFavorite(carId: string): any{

    //this.store.dispatch(DealerActions.toggleFavoriteSubmit( {carId: carId, makeFav: !this.isFavorite }))
  }

  selectImage(index: number): void{
    this.currentImageIndex = index;
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  canNewProposal(): boolean{
    let index = this.car.proposals?.findIndex(p => p.status !== ProposalStatus.CANCELLED)
    return index === -1;
  }

  canNewAppointment(): boolean{
    let index = this.car.appointments?.findIndex(p => p.status !== AppointmentStatus.CANCELLED)
    return index === -1;
  }
}
